import React from 'react'

const ImageClose = (props:any) => {
    const {close,i,item}=props
  const confirmRemove = (e: React.SyntheticEvent) => {
    e.stopPropagation()
    // Guard against accidental taps (e.g. while selecting media)
    const allow = window.confirm(
      "Remove this photo or video? It will be removed from the product."
    )
    if (!allow) return
    close(i,item)
  }
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key !== "Enter" && e.key !== " ") return
    e.preventDefault()
    confirmRemove(e)
  }
  return (
    <svg
    onClick={confirmRemove}
    onKeyDown={handleKeyDown}
    role="button"
    tabIndex={0}
    aria-label="Remove media"
    className="close"
    width="20"
    height="20"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="17"
      height="17"
      rx="4"
      fill="#262D22"
    />
    <path
      d="M12 5L5 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 5L12 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  )
}

export default ImageClose